function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { TouchableOpacity, View } from "../native";
import { useTheme } from "../../theme"; // @ts-ignore

import MaterialCommunityIcons from '@expo/vector-icons/MaterialCommunityIcons'; // import {
//   AntDesign, Entypo, EvilIcons, Feather, FontAwesome, FontAwesome5,
//   Foundation, Ionicons, MaterialCommunityIcons,
//   MaterialIcons, Octicons, SimpleLineIcons, Zocial,
// } from '@expo/vector-icons'

import * as R from 'unitx/ramda';
import wrapComponent from "../../core/wrapComponent";
import { DEFAULT_ICON_PACK } from "../../utils/constants";
export const Icons = {
  // MaterialIcons,
  // AntDesign,
  // Entypo,
  // EvilIcons,
  // Feather,
  // FontAwesome,
  // FontAwesome5,
  // Foundation,
  // Ionicons,
  MaterialCommunityIcons // Octicons,
  // SimpleLineIcons,
  // Zocial,

};
const IconNameMap = {
  AntDesign: 'AntDesign',
  Entypo: 'Entypo',
  EvilIcons: 'EvilIcons',
  Feather: 'Feather',
  FontAwesome: 'FontAwesome',
  FontAwesome5: 'FontAwesome5',
  Foundation: 'Foundation',
  Ionicons: 'Ionicons',
  MaterialCommunityIcons: 'MaterialCommunityIcons',
  MaterialIcons: 'MaterialIcons',
  Octicons: 'Octicons',
  SimpleLineIcons: 'SimpleLineIcons',
  Zocial: 'Zocial'
};
const DEFAULT_ICON_PROPS = {
  name: 'help',
  IconPack: MaterialCommunityIcons // AntDesign

};
const DEFAULT_ICON_SIZE = 24;
/**
 * ## Usage
 * A card is a sheet of material that serves as an entry point to more detailed information.
 * Heyyy
 *
 * ```js live=true
 * <Icon
 *  pack="MaterialCommunityIcons"
 *  name="delete"
 * />
 * ```
 */

function Icon(props, forwardedRef) {
  var _ref;

  const {
    onPress,
    color,
    size = DEFAULT_ICON_SIZE,
    style,
    disabled,
    pack = DEFAULT_ICON_PACK
  } = props,
        rest = _objectWithoutProperties(props, ["onPress", "color", "size", "style", "disabled", "pack"]);

  const {
    name,
    IconPack
  } = R.ifElse(R.isNotNil, TagName => {
    const iconName = R.defaultTo(DEFAULT_ICON_PROPS.name)(R.prop('name', props));
    return TagName.glyphMap[iconName] ? {
      name: iconName,
      IconPack: TagName
    } : DEFAULT_ICON_PROPS;
  }, R.always(DEFAULT_ICON_PROPS))(Icons[pack]);
  const theme = useTheme();
  const {
    iconColor,
    backgroundColor
  } = R.cond([// [
  //   R.always(status && circle),
  //   R.always({
  //     iconColor: theme[`color-${INVERT_STATUS_TYPE[status!]}-default`],
  //     backgroundColor: theme[`color-${STATUS_TYPE[status!]}-default`],
  //   }),
  // ],
  // [
  //   R.always(status),
  //   R.always({
  //     iconColor: theme[`color-${STATUS_TYPE[status!]}-default`],
  //   }),
  // ],
  [R.T, R.always({
    // @ts-ignore
    iconColor: (_ref = color !== null && color !== void 0 ? color : style === null || style === void 0 ? void 0 : style.tintColor) !== null && _ref !== void 0 ? _ref : theme === null || theme === void 0 ? void 0 : theme.colors.text
  })]])('');
  return /*#__PURE__*/React.createElement(TouchableOpacity, _extends({
    style: [{
      width: size,
      height: size
    }, style, _objectSpread({
      alignItems: 'center',
      justifyContent: 'center'
    }, backgroundColor ? {
      backgroundColor,
      borderRadius: size / 2 // '50%',

    } : {})],
    disabled: disabled !== null && disabled !== void 0 ? disabled : !onPress,
    onPress: onPress,
    ref: forwardedRef
  }, rest), /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(IconPack, _extends({
    name: name
  }, iconColor ? {
    color: iconColor
  } : {}, {
    size: backgroundColor ? size - 9 : size
  }))));
}

export default wrapComponent(Icon, {
  isForwardRef: true
});